// extracted by mini-css-extract-plugin
module.exports = {"variables":"\"../../../../assets/stylesheets/variables.scss\"","facebookColor":"#1877f2","loginButton":"FBLogin_loginButton__2cGBb","image":"FBLogin_image__2Xt8l"};